/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface TranslationGet$Params {
  translationTypeCode: string;
  langCode: string;
}

export function translationGet(http: HttpClient, rootUrl: string, params: TranslationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, translationGet.PATH, 'get');
  if (params) {
    rb.path('translationTypeCode', params.translationTypeCode, {});
    rb.path('langCode', params.langCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

translationGet.PATH = '/v1/Translation/Get/{translationTypeCode}/{langCode}';
